import { ActionType, ComponentType } from '../../enums';

export interface CreateMapLocationClickPayloadOptions {
  groupName: string;
  itemName: string;
}

export interface CreateMapLocationClickPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    group_name: string;
    item_name: string;
  };
}

export const createMapLocationClickPayload = ({
  groupName,
  itemName,
}: CreateMapLocationClickPayloadOptions): CreateMapLocationClickPayloadReturn => ({
  event_data: {
    action: ActionType.LOCATION_CLICK,
    component_type: ComponentType.MAP,
    group_name: groupName,
    item_name: itemName,
  },
});
